import { Box, Divider, useMantineTheme } from '@mantine/core'

import type { MainProps } from '@/modules/profile/components/Main/Main.types'

import { Title } from '@/components/Title/Title'

import classes from './Main.module.css'

export function Main({ children, header }: MainProps) {
  const theme = useMantineTheme()

  return (
    <Box className={classes.main}>
      <Title variant="h1">{header}</Title>

      <Divider color={theme.other.colors.lightGrey} mb={40} mt={32} />

      {children}
    </Box>
  )
}
